import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitle: {
		id: 'servicedesk-incident-management-settings.page-title',
		defaultMessage: 'Incident management',
		description: 'Title for the Incident Management Settings page',
	},
	description: {
		id: 'servicedesk-incident-management-settings.description',
		defaultMessage:
			'Manage your incident management features to help you resolve disruptions to your IT services and infrastructure.',
		description: 'Description for the Incident Management Settings page',
	},
	errorTitle: {
		id: 'servicedesk-incident-management-settings.error-title',
		defaultMessage: "We couldn't load incident settings",
		description:
			'The title text in the status flag if the responder alerts configuration status can not be fetched.',
	},
	errorDescription: {
		id: 'servicedesk-incident-management-settings.error-description',
		defaultMessage: 'Wait a moment then refresh the page to try again.',
		description:
			'The description text in the status flag if the responder alerts configuration status can not be fetched.',
	},
});
